<template>
  <!-- Page Wrapper -->
  <div id="wrapper">
    <sidebar/>
    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">

      <!-- Main Content -->
      <div id="content">

        <!-- Topbar -->
        <topbar/>
        <!-- End of Topbar -->

        <!-- Begin Page Content -->
        <child/>
        <!-- /.container-fluid -->

      </div>
      <!-- End of Main Content -->

      <!-- Footer -->
      <footer class="sticky-footer bg-white">
        <div class="container my-auto">
          <div class="copyright text-center my-auto">
            <span>Copyright &copy; {{appAuthor}} - {{appName}} (v{{appVersion}})</span>
          </div>
        </div>
      </footer>
      <!-- End of Footer -->

    </div>
    <!-- End of Content Wrapper -->
  </div>
</template>

<script>
const appName = process.env.VUE_APP_TITLE
const appVersion = process.env.VUE_APP_VERSION
const appAuthor = process.env.VUE_APP_AUTHOR

import Sidebar from '@/components/Sidebar'
import Topbar from '@/components/Topbar'

export default {
  name: 'MainLayout',
  data: () => ({
    appName: appName,
    appVersion: appVersion,
    appAuthor: appAuthor
  }),
  components: {
    Sidebar,
    Topbar
  }
}
</script>
